import featureToggleOptions from '@/shared/constants/features/featureToggleOptions'
import routeDefinitions from '@/shared/constants/routes/routeDefinitions'

const isEnabled = (key, featureToggles) => {
  if (
    !featureToggles ||
    !Object.prototype.hasOwnProperty.call(featureToggles, key)
  )
    return false

  const featureToggle = featureToggles[key]
  return featureToggle === featureToggleOptions.enabled
}

/**
 * Generates a series of feature toggle functions that will instruct which features
 * are enabled or not
 * @param {Object} featureToggles Dictionary of feature toggles
 */
export const createFeatureDecisions = (featureToggles) => {
  return {
    // #region Client Group Overview

    /**
     * UI level feature toggle that will display the client group overview UI if
     * the client enabled flag and the feature is enabled
     * @param {Boolean} clientEnabled
     * @returns
     */
    canViewClientGroupOverview(clientEnabled = false) {
      return (
        isEnabled('feature_clientGroupOverview_view', featureToggles) &&
        clientEnabled
      )
    },
    // #endregion
  }
}

/**
 * Returns value of route toggle if set or undefined
 * @param {Object} featureToggles Dictionary of feature toggles
 * @param {String} routeName
 * @returns
 */
const getRouteToggle = (featureToggles, routeName) => {
  if (
    !featureToggles ||
    !Object.prototype.hasOwnProperty.call(featureToggles, `route_${routeName}`)
  )
    return featureToggleOptions.enabled
  return featureToggles[`route_${routeName}`]
}

/**
 * Makes routing decisions based on feature toggles and the desired next route
 * @param {Object} featureToggles Dictionary of feature toggles
 * @param {*} routeTo
 * @param {Function} next
 */
export const decideRouteBasedOnFeatureToggles = (
  featureToggles,
  routeTo,
  next
) => {
  // Check if route toggle exists. If yes, decide based on value. If not, assume enabled
  const routeToggle = getRouteToggle(featureToggles, routeTo.name)

  switch (routeToggle) {
    case featureToggleOptions.enabled:
    case undefined:
      return next()
    case featureToggleOptions.underConstruction:
      return next({
        name: routeDefinitions.underConstruction.name,
        query: { redirectFrom: routeTo.fullPath },
      })
    case featureToggleOptions.disabled:
    default:
      return next({
        name: routeDefinitions.notFound.name,
        params: [routeTo.fullPath],
        replace: true,
      })
  }
}

/**
 * Checks route toggles to determine if a nav item should be displayed or not
 * @param {Object} featureToggles Dictionary of feature toggles
 * @param {String} routeName
 * @returns
 */
export const displayNavItem = (featureToggles, routeName) => {
  const routeToggle = getRouteToggle(featureToggles, routeName)
  return routeToggle === featureToggleOptions.enabled
}
